import { render, staticRenderFns } from "./PricingRulesModal.vue?vue&type=template&id=4a0e5dee"
import script from "./PricingRulesModal.vue?vue&type=script&lang=js"
export * from "./PricingRulesModal.vue?vue&type=script&lang=js"
import style0 from "./PricingRulesModal.vue?vue&type=style&index=0&id=4a0e5dee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports